function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { startLoadingFacilitatorByProject } from '../../actions/project';
import buildMiddleware from './template';
const withFacilitatorFetch = SubComponent => {
  const ComponentWithMiddlewareWrapper = buildMiddleware(SubComponent, 'WithFacilitator');
  const WithFacilitatorFetch = class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        loadedOnce: false
      };
    }
    static getDerivedStateFromProps(props, state) {
      return props.loading && !state.loadedOnce ? {
        ...state,
        loadedOnce: true
      } : state;
    }
    componentDidMount() {
      this.props.startLoadingFacilitatorByProject(this.props.selectedProjectId);
    }
    render() {
      const {
        startLoadingFacilitatorByProject,
        loading,
        ...passThroughProps
      } = this.props;
      return /*#__PURE__*/React.createElement(ComponentWithMiddlewareWrapper, _extends({
        loading: loading && !this.state.loadedOnce
      }, passThroughProps));
    }
  };
  const mapStateToProps = _ref => {
    let {
      project
    } = _ref;
    return {
      selectedProjectId: project.selectedProjectId,
      loading: project.facilitatorLoading || !project.selectedProjectFacilitator && !project.facilitatorError,
      error: project.facilitatorError
    };
  };
  const mapDispatchToProps = dispatch => ({
    startLoadingFacilitatorByProject: projectId => dispatch(startLoadingFacilitatorByProject(projectId))
  });
  WithFacilitatorFetch.propTypes = {
    selectedProjectId: PropTypes.string.isRequired,
    startLoadingFacilitatorByProject: PropTypes.func.isRequired
  };
  return connect(mapStateToProps, mapDispatchToProps)(WithFacilitatorFetch);
};
export default withFacilitatorFetch;